import { LuBriefcase, LuChefHat, LuChevronRight, LuClock3, LuStore, LuUtensilsCrossed } from "react-icons/lu";
import { Link } from "react-router-dom";

import { closingLabel, isClosingSoon, isNew } from "../lib/dates";
import { summarise } from "../lib/description";
import { careersPath } from "../lib/paths";

const ROLE_ICONS = [
  [/back of house|kitchen|cook|grill|chef|boh/i, LuChefHat],
  [/front of house|server|cashier|host|foh|crew/i, LuUtensilsCrossed],
  [/manager|supervisor|lead/i, LuStore],
];

export function RoleIcon({ title }) {
  const Icon = ROLE_ICONS.find(([pattern]) => pattern.test(title || ""))?.[1] ?? LuBriefcase;
  return (
    <span className="cr-role-icon" aria-hidden="true">
      <Icon />
    </span>
  );
}

export function RoleMeta({ job }) {
  const closing = closingLabel(job.expiry_date);
  const soon = isClosingSoon(job.expiry_date);
  return (
    <div className="cr-role-meta">
      {job.department?.name && <span className="cr-badge">{job.department.name}</span>}
      {closing && (
        <span className={`cr-badge ${soon ? "cr-badge--soon" : ""}`}>
          <LuClock3 aria-hidden="true" />
          {closing}
        </span>
      )}
      {isNew(job.created_at) && <span className="cr-badge cr-badge--new">New</span>}
    </div>
  );
}

function RoleRow({ job, withSummary }) {
  const summary = withSummary ? summarise(job.description, 150) : "";
  return (
    <li>
      <Link to={careersPath(job.slug)} state={{ fromList: true }} className="cr-role-link">
        <RoleIcon title={job.title} />
        <div>
          <h3 className="cr-role-title">{job.title}</h3>
          <RoleMeta job={job} />
          {summary && <p className="cr-role-summary">{summary}</p>}
        </div>
        <span className="cr-role-go" aria-hidden="true">
          <LuChevronRight />
        </span>
      </Link>
    </li>
  );
}

export default function RoleList({ jobs, withSummary = true, label }) {
  return (
    <ul className="cr-roles" aria-label={label}>
      {jobs.map((job) => (
        <RoleRow key={job.id} job={job} withSummary={withSummary} />
      ))}
    </ul>
  );
}

export function RoleListSkeleton({ rows = 3 }) {
  return (
    <ul className="cr-roles" aria-hidden="true">
      {Array.from({ length: rows }, (_, i) => (
        <li key={i} className="cr-role-link" style={{ display: "block" }}>
          <span className="cr-skeleton" style={{ height: 18, width: `${50 - i * 6}%` }} />
          <span className="cr-skeleton" style={{ height: 14, width: 200, marginTop: 12 }} />
          <span className="cr-skeleton" style={{ height: 14, width: "75%", marginTop: 12 }} />
        </li>
      ))}
    </ul>
  );
}
